document.addEventListener('DOMContentLoaded', function() {
  
  // 1. CONFIGURATION
  const BASE_CURRENCY = 'USD'; 
  const CURRENCY_MAP = {
    'US': { code: 'USD', symbol: '$', name: 'USA' }, 
    'CA': { code: 'CAD', symbol: '$', name: 'Canada' },     
    'AU': { code: 'AUD', symbol: '$', name: 'Australia' },  
    'NZ': { code: 'NZD', symbol: '$', name: 'New Zealand' },
    'GB': { code: 'GBP', symbol: '£', name: 'UK' },
    'DE': { code: 'EUR', symbol: '€', name: 'Germany' },
    'FR': { code: 'EUR', symbol: '€', name: 'France' },
    'JP': { code: 'JPY', symbol: '¥', name: 'Japan' },      
    'CN': { code: 'CNY', symbol: '¥', name: 'China' },      
    'HK': { code: 'HKD', symbol: '$', name: 'Hong Kong' }, 
    'TH': { code: 'THB', symbol: '฿', name: 'Thailand' }    
  };

  // 2. CLEANUP NATIVE UI & ADD MOBILE STYLES
  const style = document.createElement('style');
  style.innerHTML = `
    localization-form, .localization-form, .footer__localization, .header__localization, #FooterCountryForm, #HeaderCountryForm { display: none !important; } 
    
    /* Desktop Header Style */
    #header-currency-selector { margin-right: 2rem; } 
    #currency-select-header { cursor: pointer; font-size: 1.4rem; font-weight: 500; color: rgba(var(--color-foreground), .75); background: transparent; border: none; outline: none; padding: 0; text-decoration: underline; text-underline-offset: 0.3rem; }
    
    /* Mobile Drawer Style - ADJUSTED FOR TOP PLACEMENT */
    #mobile-currency-wrapper {
      padding: 2rem;
      margin-bottom: 1rem; /* Push content below it down */
      border-bottom: 0.1rem solid rgba(var(--color-foreground), 0.08); /* Line below */
      display: flex;
      align-items: center;
      gap: 1rem;
    }
    #currency-select-mobile {
      appearance: none;
      background: transparent;
      border: 1px solid rgba(var(--color-foreground), 0.2);
      border-radius: 4px;
      padding: 1rem;
      width: 100%;
      font-size: 1.4rem;
      color: rgb(var(--color-foreground));
    }

    /* Responsive Logic: Hide header selector on mobile */
    @media screen and (max-width: 989px) {
      #header-currency-selector { display: none !important; }
    }
  `;
  document.head.appendChild(style);

  // 3. STARTUP
  const savedCountry = localStorage.getItem('user_selected_country');
  
  if (savedCountry === 'US') {
    revealPrices();
    renderHeaderSelector('US');
    renderMobileSelector('US');
  } else if (savedCountry && CURRENCY_MAP[savedCountry]) {
    initCurrency(savedCountry);
  } else {
    fetch('https://get.geojs.io/v1/ip/country.json')
      .then(res => res.json())
      .then(data => initCurrency(CURRENCY_MAP[data.country] ? data.country : 'US'))
      .catch(() => { 
        revealPrices(); 
        renderHeaderSelector('US'); 
        renderMobileSelector('US');
      });
  }

  function initCurrency(countryCode) {
    localStorage.setItem('user_selected_country', countryCode);
    renderHeaderSelector(countryCode);
    renderMobileSelector(countryCode);
    
    if (countryCode === 'US') { revealPrices(); return; }

    const targetInfo = CURRENCY_MAP[countryCode];
    fetch(`https://open.er-api.com/v6/latest/${BASE_CURRENCY}`)
      .then(res => res.json())
      .then(rates => {
        const rate = rates.rates[targetInfo.code];
        if (!rate) { revealPrices(); return; }

        // Run frequently to catch Shopify's updates
        setInterval(() => {
          convertSimplePrices(rate, targetInfo);
          convertCartRows(rate, targetInfo);
        }, 100); 
        
        setTimeout(revealPrices, 250);
      });
  }

  function revealPrices() {
    document.documentElement.classList.remove('calculating-currency');
  }

  // --- A. SIMPLE PRICES (Product Pages) ---
  function convertSimplePrices(rate, targetInfo) {
    // Avoid anything inside a cart row or footer
    const selectors = ['.price-item', '.product-option'];
    
    document.querySelectorAll(selectors.join(', ')).forEach(el => {
      if (el.closest('tr.cart-item')) return; 
      if (el.closest('.cart__footer')) return;

      if (!el.dataset.usd) {
        let text = el.innerText;
        let match = text.match(/([0-9]+[.,]?[0-9]*)/);
        if (match) el.dataset.usd = parseFloat(match[0].replace(',', ''));
      }

      if (el.dataset.usd) {
        let usd = parseFloat(el.dataset.usd);
        let local = Math.round(usd * rate);
        let formatted = new Intl.NumberFormat('en-US').format(local);
        let str = `${targetInfo.symbol}${formatted} ${targetInfo.code}`;
        if (el.innerText !== str) {
          el.innerText = str;
          el.classList.add('converted');
        }
      }
    });
  }

  // --- B. CART ROW LOGIC (The Fix) ---
  function convertCartRows(rate, targetInfo) {
    const cartRows = document.querySelectorAll('tr.cart-item');
    let grandTotal = 0;
    let hasRows = false;

    cartRows.forEach(row => {
      // 1. Get Quantity
      const qtyInput = row.querySelector('input.quantity__input');
      const qty = qtyInput ? parseInt(qtyInput.value) : 1;

      // 2. Find ALL Potential Price Elements in this row
      // We search broadly for anything that looks like a price class
      const potentialPrices = row.querySelectorAll('.price-item, .cart-item__price-wrapper, .product-option, span, div');
      
      let rowBaseUnitUSD = 0;

      // First Pass: Identify the Base USD Unit Price
      // We look for any valid number and assume it relates to the price
      potentialPrices.forEach(el => {
         // Skip if it contains text but no numbers
         if (!el.innerText.match(/[0-9]/)) return;
         // Skip if it's purely a label
         if (el.classList.contains('visually-hidden')) return;

         // Check if we already stamped it
         if (!el.dataset.usdRaw) {
            let match = el.innerText.match(/([0-9]+[.,]?[0-9]*)/);
            if (match) {
               let val = parseFloat(match[0].replace(',', ''));
               // Sanity check: Is this likely the Total or the Unit?
               // We assume: The largest number found in the row / qty = Unit Price
               el.dataset.usdRaw = val;
            }
         }

         if (el.dataset.usdRaw) {
            let val = parseFloat(el.dataset.usdRaw);
            // Derive Unit Price (If val is 50 and qty is 2, Unit is 25)
            // We take the computed unit price as truth
            let derivedUnit = val / qty; 
            // We verify this looks like a reasonable price (e.g. > 0)
            if (derivedUnit > 0) {
               // We define the row's unit price by the first valid one we find, or overwrite if we find a larger one (total)
               // This handles the case where $25 and $50 both exist. $50/2 = 25. $25/1 = 25.
               // So the Unit Price is consistently 25.
               rowBaseUnitUSD = derivedUnit;
            }
         }
      });

      // Second Pass: Update Everything using that Base Unit Price
      if (rowBaseUnitUSD > 0) {
         hasRows = true;
         
         // 1. Calculate Local Numbers
         let localUnit = Math.round(rowBaseUnitUSD * rate); // $25 -> $35
         let localLineTotal = localUnit * qty;             // $35 * 2 = $70
         
         // 2. Accumulate Grand Total
         grandTotal += localLineTotal;

         // 3. Update Text on Screen
         potentialPrices.forEach(el => {
            if (!el.dataset.usdRaw) return;
            
            let val = parseFloat(el.dataset.usdRaw);
            
            // Is this element displaying the Unit Price or the Line Total?
            // We check tolerance (because floating point math can be .00001 off)
            let isUnit = Math.abs(val - rowBaseUnitUSD) < 0.1;
            let isTotal = Math.abs(val - (rowBaseUnitUSD * qty)) < 0.1;

            let finalAmount = 0;
            if (isUnit) finalAmount = localUnit;
            else if (isTotal) finalAmount = localLineTotal;
            else return; // Doesn't match math, skip (e.g. compare-at price)

            let formatted = new Intl.NumberFormat('en-US').format(finalAmount);
            let str = `${targetInfo.symbol}${formatted} ${targetInfo.code}`;

            // Only update the leaf node text to avoid killing HTML structure
            // If the element has children, we might need to dig deeper, but usually innerText works
            if (el.children.length === 0 && el.innerText !== str) {
               el.innerText = str;
               el.classList.add('converted');
            }
         });
      }
    });

    // --- C. UPDATE FOOTER TOTAL ---
    const totalElements = document.querySelectorAll('.totals__total-value, .totals__subtotal-value');
    totalElements.forEach(totalEl => {
      if (hasRows) {
        let fmtTotal = new Intl.NumberFormat('en-US').format(grandTotal);
        const strTotal = `${targetInfo.symbol}${fmtTotal} ${targetInfo.code}`;
        
        if (totalEl.innerText.replace(/\s/g, '') !== strTotal.replace(/\s/g, '')) {
           totalEl.innerText = strTotal;
           totalEl.classList.add('converted');
           totalEl.style.visibility = 'visible';
        }
      }
    });
  }

  // --- HEADER SELECTOR (Desktop) ---
  function renderHeaderSelector(currentCountry) {
    if (document.getElementById('header-currency-selector')) return;
    const headerIcons = document.querySelector('.header__icons');
    if (!headerIcons) return; 
    const wrapper = document.createElement('div');
    wrapper.id = 'header-currency-selector';
    wrapper.style.display = 'flex';
    wrapper.style.alignItems = 'center';
    const select = document.createElement('select');
    select.id = 'currency-select-header';
    let options = '';
    for (const [code, info] of Object.entries(CURRENCY_MAP)) {
      const selected = code === currentCountry ? 'selected' : '';
      options += `<option value="${code}" ${selected}>${info.name} (${info.code})</option>`;
    }
    select.innerHTML = options;
    wrapper.appendChild(select);
    headerIcons.insertBefore(wrapper, headerIcons.firstChild);
    select.addEventListener('change', (e) => {
      document.documentElement.classList.add('calculating-currency');
      localStorage.setItem('user_selected_country', e.target.value);
      location.reload();
    });
  }

  // --- MOBILE SELECTOR (Off-Canvas Menu) ---
  function renderMobileSelector(currentCountry) {
    // Look for the mobile menu container
    const menuDrawer = document.querySelector('.menu-drawer__inner') || document.querySelector('#menu-drawer') || document.querySelector('.js-menu-drawer');
    
    if (menuDrawer && !document.getElementById('mobile-currency-wrapper')) {
      const wrapper = document.createElement('div');
      wrapper.id = 'mobile-currency-wrapper';
      
      // Create Select
      let options = '';
      for (const [code, info] of Object.entries(CURRENCY_MAP)) {
        const selected = code === currentCountry ? 'selected' : '';
        options += `<option value="${code}" ${selected}>${info.name} (${info.code})</option>`;
      }
      
      wrapper.innerHTML = `
        <span style="font-weight:bold; font-size:1.4rem;">Currency:</span>
        <select id="currency-select-mobile">${options}</select>
      `;
      
      // --- ADJUSTMENT: INSERT AT TOP ---
      if (menuDrawer.firstChild) {
        menuDrawer.insertBefore(wrapper, menuDrawer.firstChild);
      } else {
        menuDrawer.appendChild(wrapper);
      }
      
      // Listen
      document.getElementById('currency-select-mobile').addEventListener('change', (e) => {
        document.documentElement.classList.add('calculating-currency');
        localStorage.setItem('user_selected_country', e.target.value);
        location.reload();
      });
    }
  }
});